import { CommonModule } from '@angular/common';
import { TableComponent } from './table/table.component';
import { TableEditCellComponent } from './table-edit-cell/table-edit-cell.component';
import { TableWitCheckboxComponent } from './table-with-checkbox/table-with-checkbox.component';
import { TableWitCheckboxV2Component } from './table-with-checkbox-v2/table-with-checkbox-v2.component';
import { NgModule } from '@angular/core';
import { NgZorroAntdModule, NzGridModule, NzTableModule, NzCardModule } from 'ng-zorro-antd';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { UploadFiledComponent } from './upload-filed/upload-filed.component';
import { DiaryComponent } from './diary/diary.component';
import { HarvestComponent } from './harvest/harvest.component';
import { RouterStateSnapshot } from '@angular/router';
import { RatingComponent } from './rating/rating.component';

@NgModule({
    imports: [
      CommonModule,
      NgZorroAntdModule,
      FormsModule,
      ReactiveFormsModule,
      TranslateModule,
      NzGridModule,
      NzTableModule,
      NzCardModule
    ],
    declarations: [TableComponent, UploadFiledComponent, DiaryComponent, HarvestComponent, RatingComponent, TableEditCellComponent, TableWitCheckboxComponent, TableWitCheckboxV2Component],
    exports: [
        TableComponent // <-- this!
        , UploadFiledComponent,
        DiaryComponent,
        HarvestComponent,
        RatingComponent,
        TableEditCellComponent,
        TableWitCheckboxComponent,
        TableWitCheckboxV2Component,
    ]
  })
  export class ComponentsModule { }
